import { Actions } from "easy-peasy";
import { useEffect, useCallback } from "react";
import { ApplicationStateAndActions, useStoreActions } from "../../appstore";
import {
  GeoInferenceEndpoint,
  Campaign,
  ListJobsResponse,
} from "../../appstore/models";
import _ from "lodash";

interface DataModel {
  geoInferenceEndpoints: GeoInferenceEndpoint[];
  currentGeoLabelingJobConfiguration: Campaign;
  geoLabelingJobConfigurations: ListJobsResponse;
}

const initializeAppState = (
  dataModel: DataModel,
  actions: Actions<ApplicationStateAndActions>
) => {
  actions.setCurrentCampaign({
    ...dataModel.currentGeoLabelingJobConfiguration,
  });
  actions.setCampaigns(
    dataModel.geoLabelingJobConfigurations.FeatureDetectionJobPropertiesList.map(
      (summary) => ({
        ...summary,
        id: _.uniqueId("geo-labeling-job-configuration-summary-"),
      })
    )
  );

  actions.setGeoInferenceEndpoints(dataModel.geoInferenceEndpoints);
};

const InitializeApp = () => {
  const actions = useStoreActions((a) => a);
  const sampleDataUrl =
    process.env.REACT_APP_SAMPLE_DATA_URL || "/sample-data/sample01.json";
  // Todo: re-initialize if the page changes

  const initialize = useCallback(async () => {
    // Todo: this is getting called twice. Should only be called once
    const result = await fetch(`${process.env.PUBLIC_URL}${sampleDataUrl}`);

    const resultObj = (await result.json()) as DataModel;

    initializeAppState(resultObj, actions);
  }, [sampleDataUrl, actions]);

  useEffect(() => {
    initialize();
  }, [initialize]);
  return null;
};
export default InitializeApp;
